<template>
  <div class="PClogin">
    <div class="login-box">
      <!-- <h2>登 录</h2> -->
      <form style="margin: 10%;">
        <div class="user-box">
          <input type="text" name="" required="" v-model="value" @blur="animate()" v-on:change="changeValue"
            onkeyup="value=value.replace(/[^\d]/g,'')" maxlength=11>
          <label :style="{ color: activeCls }">{{phone}}</label>
        </div>
        <div class="user-box">
          <input type="password" name="" required="" v-model="pass">
          <label>密码</label>
        </div>
        <a href="#" @click="login">
          <span></span>
          <span></span>
          <span></span>
          <span></span>
          <!-- Submit -->
          登录
        </a>
      </form>
    </div>
    <el-dialog title="提示" :visible.sync="centerDialogVisible" width="30%" center append-to-body>
      <span>扫描二维码进行注册使用</span>
      <img src="../assets/basicprofile.png" />
      <span slot="footer" class="dialog-footer" style="text-align: center;">
        <el-button @click="centerDialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="centerDialogVisible = false">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
  import {
    PCusershow
  } from '../../static/API/API.js'
  export default {
    name: 'login',
    data() {
      return {
        labelPosition: 'right',
        centerDialogVisible: false,
        formLabelAlign: {
          name: '',
          region: '',
          type: ''
        },
        value: '',
        pass: '',
        phone: '手机号',
        activeCls: '',
      }
    },
    mounted() {

    },
    methods: {
      login() {
        let params =new URLSearchParams()
        params.append('tel',this.value)
        params.append('password',this.pass)
        this.$axios.get(PCusershow, {params}).then(res => {
          if (res.data == 'no') {
            this.centerDialogVisible = true
          }else{
            this.$router.push('/PCmerchandise')
            sessionStorage.setItem('collection',res.data[0].collection)
            sessionStorage.setItem('credits',res.data[0].credits)
            sessionStorage.setItem('openid',res.data[0].openid)
            sessionStorage.setItem('name',res.data[0].name)
            sessionStorage.setItem('address',res.data[0].address)
            sessionStorage.setItem('salesman',res.data[0].salesman)
            sessionStorage.setItem('customer',res.data[0].companyid)
             this.$parent.close()
             this.$parent.pagefeed()
          }
        })

      },
      changeValue(e) {
      },
      animate() {
        var re = /^1\d{10}$/;
        let str = this.value;
        if (re.test(str)) {
          // alert('成功')
        } else {
          this.activeCls = 'red'
          this.phone = '手机号不准确'
        }
      }
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .login-box {
    /* position: absolute;
    top: 50%;
    left: 50%;
    width: 400px;
    padding: 40px;
    transform: translate(-50%, -50%); */
    background: rgba(255, 255, 255, 1);
    box-sizing: border-box;
    /* box-shadow: 0 15px 25px rgba(0, 0, 0, .6); */
  }

  .login-box h2 {
    margin: 0 0 30px;
    padding: 0;
    color: #000000;
    text-align: center;
  }

  .login-box .user-box {
    position: relative;
  }

  .login-box .user-box input {
    width: 100%;
    padding: 10px 0;
    font-size: 16px;
    /* color: #fff; */
    margin-bottom: 30px;
    border: none;
    border-bottom: 1px solid #000000;
    outline: none;
    background: transparent;
  }

  .login-box .user-box label {
    position: absolute;
    top: 0;
    left: 0;
    padding: 10px 0;
    font-size: 16px;
    color: #000000;
    pointer-events: none;
    transition: .5s;
  }

  .login-box .user-box input:focus~label,
  .login-box .user-box input:valid~label {
    top: -20px;
    left: 0;
    color: #03e9f4;
    font-size: 12px;
  }

  .login-box form a {
    position: relative;
    display: inline-block;
    padding: 10px 70px;
    color: #000000;
    font-weight: 700;
    font-size: 16px;
    text-decoration: none;
    text-transform: uppercase;
    overflow: hidden;
    transition: .5s;
    margin-top: 40px;
    letter-spacing: 4px;
    background-color: #409eff;
  }

  .login-box a:hover {
    background: #03e9f4;
    color: #fff;
    border-radius: 5px;
    box-shadow: 0 0 5px #03e9f4,
      0 0 25px #03e9f4,
      0 0 50px #03e9f4,
      0 0 100px #03e9f4;
  }

  .login-box a span {
    position: absolute;
    display: block;
  }

  .login-box a span:nth-child(1) {
    top: 0;
    left: -100%;
    width: 100%;
    height: 2px;
    background: linear-gradient(90deg, transparent, #ff0000);
    animation: btn-anim1 1s linear infinite;
  }

  @keyframes btn-anim1 {
    0% {
      left: -100%;
    }

    50%,
    100% {
      left: 100%;
    }
  }

  .login-box a span:nth-child(2) {
    top: -100%;
    right: 0;
    width: 2px;
    height: 100%;
    background: linear-gradient(180deg, transparent, #03e9f4);
    animation: btn-anim2 1s linear infinite;
    animation-delay: .25s
  }

  @keyframes btn-anim2 {
    0% {
      top: -100%;
    }

    50%,
    100% {
      top: 100%;
    }
  }

  .login-box a span:nth-child(3) {
    bottom: 0;
    right: -100%;
    width: 100%;
    height: 2px;
    background: linear-gradient(270deg, transparent, #03e9f4);
    animation: btn-anim3 1s linear infinite;
    animation-delay: .5s
  }

  @keyframes btn-anim3 {
    0% {
      right: -100%;
    }

    50%,
    100% {
      right: 100%;
    }
  }

  .login-box a span:nth-child(4) {
    bottom: -100%;
    left: 0;
    width: 2px;
    height: 100%;
    background: linear-gradient(360deg, transparent, #03e9f4);
    animation: btn-anim4 1s linear infinite;
    animation-delay: .75s
  }

  @keyframes btn-anim4 {
    0% {
      bottom: -100%;
    }

    50%,
    100% {
      bottom: 100%;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/PClogin.vue